export default __webpack_public_path__ + "static/media/electronics.f49daea6.jpg";